import * as React from 'react';
import {useDispatch} from 'react-redux';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {convertToArray} from 'nutshell-core/filter';

import type {LandingPageFullFragment} from 'nutshell-graphql-types';

import {getReportDateRanges} from '../../reports/report-constants';
import {ReportDateRangePickerSimple} from '../../reports/report-date-range-picker-simple';
import type {ReportURLParams} from '../../reports/report-types';

import {LandingPagesReportChart} from '../report/landing-pages-report-chart';
import {requestLandingPagesReportData} from '../report/pages-actions';
import type {LandingPagesChartParams} from '../report/pages-utils';

import styles from './engagement-tab.module.css';

type Props = ContextRouter & {
    page: LandingPageFullFragment | null | undefined;
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
};

export function EngagementTab(props: Props) {
    const pageId = props.page && props.page.id;
    const {filter, report} = props.urlParams;
    const dispatch = useDispatch();

    const fetchReportData = (reportParams: LandingPagesChartParams, filters: any[]) => {
        dispatch(requestLandingPagesReportData({reportParams, filters}));
    };

    React.useEffect(() => {
        if (pageId) {
            const newFilter = convertToArray(filter || {});
            fetchReportData({...report, pageId}, newFilter);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, report, pageId]);

    const reportParams = props.urlParams.report || {};

    return (
        <>
            <div className={styles['period-picker']}>
                <ReportDateRangePickerSimple
                    activeFilters={convertToArray(props.urlParams.filter)}
                    dateRangeType='period'
                    // @ts-expect-error
                    dateRangeOptions={getReportDateRanges('landingPages')}
                    onDateRangeChange={(newFilter) => {
                        props.onParamChange(
                            {filter: {...props.urlParams.filter, ...newFilter}},
                            true
                        );
                    }}
                />
            </div>
            <div className='full-width'>
                <LandingPagesReportChart
                    hasBorder={true}
                    hasGap={false}
                    activeFilters={convertToArray(props.urlParams.filter)}
                    height={480}
                    onParamChange={props.onParamChange}
                    // @ts-expect-error
                    reportKey='landingPages'
                    reportParams={reportParams}
                />
            </div>
        </>
    );
}
